import React, { useContext, useState, useEffect } from 'react';
import { STWContext } from '../../widgets/STW/context';
import useIsMobile from '../../hooks/useIsMobile';

const SelectedCountry: React.FC<{
  toggleDropDown: (flag: boolean) => void;
  showDropdown: boolean;
  fontColour: string;
  selectedCountryData: { code: String; dial: String };
  size?: 'small' | 'large';
}> = ({
  toggleDropDown,
  showDropdown,
  selectedCountryData,
  fontColour,
  size,
}) => {
  const { preview, isMobile } = useContext(STWContext);
  const isMobileDevice = useIsMobile();
  const [currentStyle, setCurrentStyle] = useState<any>(null);

  useEffect(() => {
    const importStyles = async () => {
      let stylesModule;
      if (preview) {
        if (isMobile) {
          stylesModule = await import(
            './selectedCountryPreviewMobile.module.css'
          );
        } else {
          stylesModule = await import(
            './selectedCountryPreviewDesktop.module.css'
          );
        }
      } else {
        stylesModule = await import('./selectedCountry.module.css');
      }
      setCurrentStyle(stylesModule.default);
    };
    importStyles().then();
  }, [preview, isMobile]);

  if (!currentStyle) {
    return <></>;
  }

  return (
    <div
      className={currentStyle.bikStwCountryCodePicker}
      onClick={() => toggleDropDown(!showDropdown)}
      style={
        size === 'small' || preview ? {} : { height: isMobileDevice ? 38 : 48 }
      }
    >
      <div className={currentStyle.bikStwCountryCodeContainer}>
        <img
          alt={''}
          className={currentStyle.bikStwCountryFlag}
          src={`https://flagcdn.com/${selectedCountryData.code.toLowerCase()}.svg`}
        />
        <div
          className={currentStyle.bikStwH2}
          style={{ color: fontColour, margin: 0 }}
        >
          {selectedCountryData.dial}
        </div>
        <div
          className={currentStyle.bikStwDownArrow}
          style={{ borderTopColor: fontColour }}
        ></div>
      </div>
    </div>
  );
};
export default SelectedCountry;
